<template>
  <div class="copyright_container">
    <div class="copyright_box">
      <div class="title_box">
        <h2>“法治号”客户端<br />版权声明</h2>
      </div>
      <div class="content_box">
        <p>“法治号”客户端上的所有内容，包括但不限于文字、图片、声音、录像、图表、标志、标识、广告、商标、商号、域名、软件、程序、版面设计、内容分类标准以及为用户提供的任何信息，均受法律的保护，为法治日报社及其相关权利人专属所有或持有。</p>
        <p>使用者将“法治号”客户端提供的内容与服务用于非商业用途、非盈利、非广告目的而纯属个人使用时，应遵守相关法律的规定，不得侵犯法治日报社及其相关权利人的合法权益，否则将追究有关人员的侵权责任。</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Copyright",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "法治号客户端版权声明", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
  },
  created() {
    document.title = "法治号客户端版权声明";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.copyright_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .copyright_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    * {
      word-break: normal;
      white-space: normal;
      line-height: 1.5em;
      font-family: "Microsoft Yahei";
    }
    .title_box {
      h2 {
        padding: 16px 0;
        line-height: 27px;
        text-align: center;
        color: #212121;
        font-size: 18px;
        font-weight: bolder;
      }
    }
    .content_box {
      p {
        line-height: 27px;
        margin: 5px 0;
        color: #212121;
        font-family: "Microsoft Yahei";
        font-size: 18px;
        text-indent: 2em;
        text-align: justify;
        * {
          font-family: "Microsoft Yahei";
          text-align: justify;
        }
      }
    }
  }
}
</style>